import { HttpClient } from "@angular/common/http";
import { TranslateHttpLoader } from "@ngx-translate/http-loader";
import { APP_MODEL_DATA } from "./core/const-data";

// HTTP Translate Loader
export function langTranslateHttpLoader(http: HttpClient) {
    return new TranslateHttpLoader(http, './assets/i18n/', '.json?version='+ APP_MODEL_DATA.LANG_VERSION);
}